import { TableContainer } from "@/components/table-container";
import { Table, Drawer } from "@renderbus/ui";
import styled from "styled-components";
import { columns } from "./config/table-columns";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SettingButton } from "../../atom";
import { ChildManageInitPage } from "./components/child-manage-init";
import { DingTalkSubAccountProvider } from "./store/dingtalk-subaccount-store";
import { SettingOutlined } from "@ant-design/icons";
import { ChildIntegrationEchoSetting } from "./components/child-integration-echo";
import { ChildManageSider } from "./components/child-manage-sider";
import Loading from "@/components/Loading";
import { ISubAccountData, useSubAccountStore } from "@/store/SubAccountStore";
import { useDingTalkChildManage } from "./hooks/useDingTalkChildManage";
import InputSelect from "./components/input-select";
import { useMemo } from "react";
import { Whether } from "project-config/constants";
import { ColumnType } from "antd/es/table";
import { useGlobalStore } from "@/store/GlobalStore";
export interface ISubAccountForm {
  subUserName: string;
  subPassword: string;
  phone: string;
  email: string;
  status: number;
}

function DingTalkChildManageView() {
  const t = getTranslateNsT("childManager");
  const { dingTalkAccountList } = useSubAccountStore();
  const {
    contextHolder,
    deptInfo,
    initPageLoading,
    openSettingModal,
    setOpenSettingModal,
    isInitPage,
  } = useDingTalkChildManage();
  const { userInfo } = useGlobalStore();
  const _columns = useMemo(
    () =>
      columns.map((column: ColumnType<ISubAccountData>) => {
        if (column.dataIndex === "cloudCoupon") {
          return {
            ...column,
            hidden: userInfo?.enableRemoteDesktop === Whether.No,
          };
        }
        return column;
      }),
    [userInfo?.enableRemoteDesktop]
  );
  return (
    <ChildManageWrapper isInitPage={isInitPage}>
      {contextHolder}
      {initPageLoading ? (
        <Loading />
      ) : isInitPage ? (
        <ChildManageInitPage />
      ) : (
        <ChildManageTableContainer>
          <ChildManageSider dataSource={deptInfo} />
          <ChildManageTableWrapper>
            <OperationArea>
              <div>
                <span style={{ marginRight: 8 }}>
                  {t("dingtalk_subaccount_username_1")}
                </span>
                <InputSelect />
              </div>
              <SettingButton
                icon={<SettingOutlined />}
                onClick={() => setOpenSettingModal(true)}
              >
                {t("dingtalk_subaccount_echo_tab1")}
              </SettingButton>
            </OperationArea>
            <Table
              id="child-customer-table"
              columns={_columns}
              dataSource={dingTalkAccountList}
              hidePaginationOnSinglePage={true}
              pagination={false}
              scroll={{ y: "calc(100vh - 280px)" }}
            />
          </ChildManageTableWrapper>
          <Drawer
            width={998}
            open={openSettingModal}
            title={t("dingtalk_subaccount_integration_settings")}
            onClose={() => setOpenSettingModal(false)}
            headerStyle={{ display: "none" }}
            destroyOnClose
            drawerContent={<ChildIntegrationEchoSetting />}
          />
        </ChildManageTableContainer>
      )}
    </ChildManageWrapper>
  );
}

export function DingTalkChildManage() {
  return (
    <DingTalkSubAccountProvider>
      <DingTalkChildManageView />
    </DingTalkSubAccountProvider>
  );
}
const ChildManageWrapper = styled.div<{ isInitPage: boolean }>`
  position: relative;
  height: calc(100vh - 150px);
`;
const OperationArea = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px 24px 16px 0;
  justify-content: space-between;
  .ant-btn {
    height: 36px;
  }
  .ant-input {
    width: 300px;
  }
`;

const ChildManageTableContainer = styled(TableContainer)`
  display: flex;
  gap: 24px;
  flex-direction: row;
  padding: 0;
  height: 100%;
  .dingtalk-posts {
    position: absolute;
    color: var(--main-color);
    border-color: var(--main-color);
    top: -18px;
    padding: 0 4px;
  }
`;

const ChildManageTableWrapper = styled.div`
  width: 100%;
  overflow: auto;
  .ant-table-wrapper {
    overflow: auto;
  }
`;
